import { Input, Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ConversationModel } from "../../../../app/models/conversationModel";

@Component({
  selector: 'new-conversation-dialog-component',
  templateUrl: './new-conversation-dialog.component.html',
  styleUrls: ['./new-conversation-dialog.component.css']
})
export class NewConversationDialogComponent implements OnInit {
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() conversation: ConversationModel;

  constructor(public activeModal: NgbActiveModal,) { }

  ngOnInit() {
  }

  public decline() {
    this.activeModal.dismiss();
  }

  public accept() {
    this.activeModal.close(this.conversation);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
